import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setValidationInfo } from "../features/authorizationSlice";
import useLogout from "../api/logoutApi";
import { setFlagMobile, setIsPopupMobile, setResponseDescriptionMobile, setResponseTitleMobile } from "../features/appMobileSlice";
import { setLoading } from "../features/responseSlice";

const useResponseMobile = () => {
  const dispatch = useDispatch();
  const { logout } = useLogout();
  const successResponseMobile = (res) => {

    dispatch(setValidationInfo(null));
    dispatch(setLoading("idle"));

    // if (Number(res?.flagCode) === 84) {
    //   dispatch(setFlag(84));
    //   dispatch(
    //     setResponseInfo({
    //       amount: res?.amount,
    //       currencyFrom: res?.currencyFrom,
    //       currencyTo: res?.currencyTo,
    //     })
    //   );
    //   dispatch(setIsPopup(true));
    //   dispatch(setResponseTitle(res.Title));
    //   dispatch(setResponseDescription(res.Message));
    //   return;
    // }

    // if (Number(res?.flagCode) === 90) {
    //   dispatch(setFlag(90));
    //   dispatch(
    //     setResponseInfo({
    //       amount: res?.amount,
    //       currencyFrom: res?.currencyFrom,
    //       currencyTo: res?.currencyTo,
    //     })
    //   );
    //   dispatch(setIsPopup(true));
    //   dispatch(setResponseTitle(res.Title));
    //   dispatch(setResponseDescription(res.Message));
    //   return;
    // } 
    // if (Number(res?.flagCode) === 11) {
    //   dispatch(setFlag(11));
    //   dispatch(
    //     setResponseInfo({
    //       amount: res?.amount,
    //       currencyFrom: res?.currencyFrom,
    //       currencyTo: res?.currencyTo,
    //     })
    //   );
    //   dispatch(setIsPopup(true));
    //   dispatch(setResponseTitle(res.Title));
    //   dispatch(setResponseDescription(res.Message));
    //   return;
    // }

    if (res.isPopup) {

      dispatch(setIsPopupMobile(true));
      dispatch(setFlagMobile(res?.flagCode || 0));
      dispatch(setResponseTitleMobile(res.Title));
      dispatch(setResponseDescriptionMobile(res.Message));
    //   if(res.InstallEsim){
    //     dispatch(setResponseInfo({InstallEsim: res.InstallEsim}));
    //   }
    } else {
      dispatch(setFlagMobile(0));
      //res.Title?
      toast.success(res.Message || res.Title);
    }

    // if (res.Payload.isPopup) {
    //   dispatch(setIsPopup(true));
    //   dispatch(setFlag(res?.Payload.flagCode || 0));
    //   dispatch(setResponseTitle(res.Payload.Title));
    //   dispatch(setResponseDescription(res.Payload.Message));
    // } else {
    //   dispatch(setFlag(0));
    //   //res.Title?
    //   toast.success(res.Payload.Message || res.Payload.Title);
    // }
    
  };

  

  const errorResponseMobile = (error) => {
    const errorData = error?.response?.data || error;

    if (errorData?.isPopup) {
      if (errorData.PopupTitle === "LoaderError") return;
      
      if (error?.response?.status === 435 || error?.response?.status === 436) {
        dispatch(setFlagMobile(error.response.status));
      } else {
        dispatch(setFlagMobile(10));
      }
      dispatch(setLoading("idle"));
      dispatch(setIsPopupMobile(true));
      dispatch(setResponseTitleMobile(errorData.PopupTitle));
      dispatch(setResponseDescriptionMobile(errorData.PopupDescription));
    } else {
      dispatch(setLoading("pending"));
    }
  };
  

  return {
    successResponseMobile,
    errorResponseMobile,
  };
};
export default useResponseMobile;
